import { Reducer } from 'redux';
import { INavMenuActions, NavMenuActionType } from 'redux/actions/NavMenuActions';

const initialState: boolean = true;
export const navMenuReducer: Reducer<boolean, INavMenuActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case NavMenuActionType.TOGGLE_NAV_MENU:
                {
                    return !state;
                }
            default:
                return state;
        }
    };
